import processData from "../../data/projectOutsourcingProcess.json";

export default function Section6() {
  return (
    <div className="Section6 p-[2%] my-[66px] md:mb-[4%] md:mt-[5%] text-center bg-[url('/public/assets/magento-rectangle.png')]">
      <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-white my-[0.67em]">
        Our Process
      </h2>

      <div
        className={`flex flex-col md:flex-row w-[80%] justify-center p-[0.2%_0%_1.5%_0%] md:p-[2%_0%_1%_0%] md:mb-[25px] mx-auto`}
      >
        {processData.map(({ number, title, list }, index) => {
          return (
            <div
              key={title + index}
              className={`bg-white text-left  rounded-[10px] md:w-[33.33%] m-[10px_8px] p-[15px_20px]`}
            >
              <h2 className="text-[45px] text-[#DA2128] mt-5 mb-[10px] font-[500] leading-[40px]">
                {number}
              </h2>

              <h3
                className={`font-bold my-[0.67em] text-[16px] text-black leading-[26px]`}
              >
                {title}
              </h3>

              <p className="text-[#373737] mb-5 text-[14px] font-open">
                {list.map((item) => {
                  return (
                    <>
                      • {item}
                      <br></br>
                    </>
                  );
                })}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
